import { DocumentIcon } from "components/vectors/document-icon";

import { ReactNode } from "react";
import { HomeIcon } from "components/vectors/menu-icons/home-icon";
import { MegaphoneIcon } from "components/vectors/menu-icons/mega-phone-icon";
import { PersonIcon } from "components/vectors/menu-icons/person-icon";
import { WalletIcon } from "components/vectors/menu-icons/wallet-icon";
import { PhoneIcon } from "components/vectors/menu-icons/phone-icon";
import { RiRobot2Line } from "react-icons/ri";

export interface SubItemProps {
  name: string;
  href: string;
  subItems?: undefined;
}

export interface MenuItemProps {
  name: string;
  subItems?: SubItemProps[];
  href?: string;
  icon: JSX.Element | ReactNode;
}

export const menuArray: MenuItemProps[] = [
  {
    name: "Home",
    href: "/",
    icon: <HomeIcon />,
  },
  {
    name: "Acessos",
    icon: <PersonIcon />,
    subItems: [
      { name: "Empresas", href: "/empresas" },
      { name: "Usuários Corban", href: "/usuarios" },
      { name: "Equipes de Venda", href: "/equipes-de-venda" },
      { name: "Usuários Bancos", href: "/usuarios-bancos" },
      { name: "Sessões WhatsApp", href: "/sessoes-whatsapp" },
    ],
  },
  {
    name: "Carteira",
    icon: <WalletIcon />,
    subItems: [
      { name: "Transações", href: "/carteira" },
      { name: "Serviços", href: "/servicos" },
    ],
  },
  {
    name: "Mailing",
    icon: <MegaphoneIcon />,
    subItems: [
      { name: "Mailing Lista", href: "/mailing" },
      { name: "Campanha WhatsApp", href: "/campanha-whatsapp" },
      { name: "Campanha SMS", href: "/campanha-sms" },
    ],
  },
  {
    name: "Consultas",
    icon: <DocumentIcon />,
    subItems: [
      { name: "Offline INSS", href: "/consulta" },
      { name: "Consulta HOT", href: "/consulta-hot" },
      // { name: "Extrato", href: "/extrato-online-avulso" },
      { name: "Telefonia", href: "/consulta-telefonia" },
    ],
  },
  {
    name: "Atendimento",
    icon: <PhoneIcon />,
    subItems: [
      { name: "Atendimentos", href: "/atendimentos" },
      // { name: "Tabela Digitação", href: "/tabelas-digitacao" },
      { name: "Tabelas Digitação", href: "/tabelas" },
    ],
  },
  {
    name: "VendeAI",
    icon: <RiRobot2Line size="25px" />,
    href: "/vende-ai",
  },
];
